import React, { MouseEventHandler } from 'react';
import { Box, Button, Text } from '@doda/io-react/common';
import styles from './index.module.scss';

/**
 * MemberRegistForRightのProps
 * @param memberRegistLink 会員登録用リンク
 * @param guideLoginLink 「ログインはこちら」用リンク
 * @param introLink 「はじめてdodaをご利用される方へ」用リンク
 */
export interface Props {
  memberRegistLink: string;
  guideLoginLink: string;
  introLink: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
}

export const MemberRegistForRight: React.FC<Props> = ({
  memberRegistLink,
  guideLoginLink,
  introLink,
  onClick,
}) => {
  return (
    <Box className={styles.memberRegistForRightWrapper}>
      <div className={styles.memberRegistForRightWrapper__btnArea}>
        <Button
          as="a"
          href={memberRegistLink}
          onClick={onClick}
          variant="orange"
          className="memberRegistForRightWrapper__btnArea__button"
        >
          会員登録する
          <span className="memberRegistForRightWrapper__btnArea__span">
            (無料)
          </span>
        </Button>
        <Text className="memberRegistForRightWrapper__loginText">
          ログインは
          <a
            className="memberRegistForRightWrapper__userclick"
            href={guideLoginLink}
          >
            こちら
          </a>
        </Text>
      </div>
      <Button
        as="a"
        href={introLink}
        onClick={onClick}
        variant="outline_gray"
        className="memberRegistForRightWrapper__forFirstBtn"
      >
        はじめてdodaをご利用される方へ
      </Button>
    </Box>
  );
};
